import FilterWordsField from '../../../../controls/FilterWordsField'
import {UserManagementConstants} from '../../../../constants'
import $ from 'jquery'

function UserTableRenderer() {
    this.constructor = UserTableRenderer;
}

UserTableRenderer.sortOrderClasses = [];
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_NAME] = "sortByName";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_GROUP_NAME] = "sortByGroupName";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_PTO_BALANCE] = "sortByPTO";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_PTO] = "sortByApprovedPTO";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_PTO_CONTROL_STATUS] = "sortByPTOControl";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_SICK_BALANCE] = "sortBySick";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_APPROVED_SICK] = "sortByApprovedSick";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_SICK_CONTROL_STATUS] = "sortBySickControl";
UserTableRenderer.sortOrderClasses[UserManagementConstants.USER_LIST_ORDER_BY_TIME_ZONE_GROUP_NAME] = "sortByTimeZoneGroupName";

UserTableRenderer.prototype.init = function() {
    return this;
};

UserTableRenderer.prototype.setupEventHandlers = function(handlersMap) {
    document.getElementById("sortByPTOLink").onclick = handlersMap.sortByPTO;
    document.getElementById("sortByApprovedPTO").onclick = handlersMap.sortByApprovedPTO;
    document.getElementById("sortByPTOControl").onclick = handlersMap.sortByPTOControl;
    document.getElementById("sortBySickLink").onclick = handlersMap.sortBySick;
    document.getElementById("sortByApprovedSick").onclick = handlersMap.sortByApprovedSick;
    document.getElementById("sortBySickControl").onclick = handlersMap.sortBySickControl;
};

UserTableRenderer.prototype._getViewerRightsClasses = function(canEditUsers, showPTO, showPTOSettings, showSick, showSickSettings, showAccountSettings) {
    const classes = [];
    if (canEditUsers)
        classes.push("canEditUsers");
    if (!showPTOSettings) {
        classes.push("hidePTOSettings");
    }
    if (!showSickSettings) {
        classes.push("hideSickSettings");
    }
    if (!showPTO && !showSick)
        classes.push("hideBalances");
    if (!showAccountSettings)
        classes.push("hideAccountSettings");
    return classes;
};

UserTableRenderer.prototype._getSortClasses = function(sortOrder, asc) {
    const classes = [UserTableRenderer.sortOrderClasses[sortOrder]];
    if (!asc)
        classes.push("desc");
    return classes;
};


UserTableRenderer.prototype.updateUI = function(table, canEditUsers, canManageLeaveBalances, showPTO, showSick, showAccountSettings, sortOrder, asc) {
    const viewerRightsClasses = this._getViewerRightsClasses(canEditUsers, showPTO, canManageLeaveBalances, showSick, canManageLeaveBalances,
        showAccountSettings);
    const sortClasses = this._getSortClasses(sortOrder, asc);
    const classes = ["userListTable"].concat(viewerRightsClasses).concat(sortClasses);
    table.getTableEl().className = classes.join(" ");
};

export default UserTableRenderer



// WEBPACK FOOTER //
// ./web/js/administration/userManagement/userList/table/UserTableRenderer.js